import Vue from "vue";
import Router from "vue-router";
import LandingPage from "./views/LandingPage.vue";
import store from "./store/index";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "landing-page",
      component: LandingPage,
      meta: {
        currentFlowName: "Landing Page",
        title: "CommerceHealthcare",
      },
    },
    {
      path: "/enroll//",
      name: "enroll",
      component: () => import("./views/Enrollment"),
      meta: {
        currentFlowName: "Enroll for HSF",
        title: "HSF Enrollment | Choose Provider",
      },
      beforeEnter: (to, from, next) => {
        let guid = to.query.guid || to.query.GUID;

        // Redirect to landing page if no query param present
        // Don't need people accessing the old enroll path
        if (!guid) {
          next("/search");
        }

        if (guid) {
          store.dispatch("setGuid", guid);
          store.dispatch("setSelectedProviderByGuid", guid);
        } else if (
          Object.keys(to.query).length !== 0 &&
          to.query.constructor === Object
        ) {
          store.dispatch("setGuidError", true);
        }

        next();
      },
    },
    {
      path: "/search//",
      name: "search",
      component: () => import("./views/Enrollment"),
      meta: {
        currentFlowName: "Find your provider",
        title: "Search for your Provider",
      },
      beforeEnter: (to, from, next) => {
        let guid = to.query.guid || to.query.GUID;
        if (guid) {
          store.dispatch("setGuid", guid);
          store.dispatch("setSelectedProviderByGuid", guid);
        } else if (
          Object.keys(to.query).length !== 0 &&
          to.query.constructor === Object
        ) {
          store.dispatch("setGuidError", true);
        }
        next();
      },
    },
    {
      path: "/search/:step",
      name: "enroll-forms",
      component: () => import("./views/EnrollmentForms"),
      meta: {
        currentFlowName: "Enroll for HSF",
        title: "HSF Enrollment | Enroll",
      },
      beforeEnter: (to, from, next) => {
        if (
          Object.keys(store.state.selectedProvider).length === 0 &&
          store.state.selectedProvider.constructor === Object
        ) {
          next({ name: "search" });
        } else {
          next();
        }
      },
    },
    {
      path: "/Verifyyouremail/:token",
      name: "Verifyyouremail",
      component: () => import("./views/Verifyyouremail.vue"),
      props: true

    },
    {
      path: "/optout",
      name: "optout",
      component: () => import("./views/OptOut.vue"),
      props: true

    },

    {
      path: "/error",
      name: "error",
      component: () => import("./views/ErrorPage"),
    },
    {
      path: "*",
      name: "catchAll",
      redirect: "/",
    },
    {
      path: "/epic/integration",
      name: "epic-integration",
      component: () => import("./views/EpicIntegration.vue"),
      meta: {
        currentFlowName: "Epic Integration",
        title: "Epic Integration",
      },
    }
  ],
});

router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  // check for submission complete flag
  if (store.state.submissionComplete && to.path !== "/search/success") {
    store.dispatch("setFormValues", {});
    store.dispatch("resetSelectedProvider");
    store.dispatch("resetSearchedProviders");
    store.dispatch("resetCurrentStepIndex");
    store.dispatch("setSubmissionComplete", false);
    store.dispatch("setShowFeedbackModal", false);
  }

  // Check for cached feature flags and call api if necessary
  if (store.state.featureFlags === null) {
    store.dispatch("setFeatureFlags").then(() => {
      next();
    });

  } else {
    next();
  }
});



export default router;
